<div class="slide-controls">
    <div class="slide-control-button-title-group">
        <span class="slide-control-button" (click)="previousStory()"><i class="theme-move-left"></i></span>
        @if (stories[activeStory - 1]) {
            <span class="story-title previous-title">{{ stories[activeStory - 1].title || '' }}</span>
        }
    </div>
    <span class="slide-control-button" (click)="previousSubStory()"><i class="theme-left"></i></span>
</div>
@if (subStory) {
    <div class="story-body">
        <ms-sub-story-body [subStory]="subStory" [story]="story" />
        <div
            class="story-tap-overlay"
            (touchstart)="setProgressBarStatus(true)"
            (touchend)="setProgressBarStatus(false)"
            (panmove)="setProgressBarStatus(true)"
            (panend)="handlePanEvent($event, subStory)"
            (pancancel)="handlePanEvent($event, subStory)">
            <div class="left-tap" (click)="previousSubStory()"></div>
            <div class="right-tap" (click)="nextSubStory()"></div>
        </div>
        <div class="story-click-overlay-desktop" (click)="controlsClick()">
            @if (paused && controlsVisible) {
                <span class="slide-control-button pause-button">
                    <i class="theme-pause"></i>
                </span>
            }
            @if (!paused && controlsVisible) {
                <span class="slide-control-button play-button">
                    <i class="theme-play-solid"></i>
                </span>
            }
        </div>
        @if (subStory.ctaEnabled && subStory.type !== 'Promotion') {
            <div class="see-more" (click)="handleCTA(subStory.ctaRedirectionLink, $event, true)">
                <span class="see-more-text">{{ subStory.ctaButtonText }}</span>
                <span class="see-more-icon">
                    <i [ngClass]="subStory.ctaRedirectionLink ? 'theme-right' : 'theme-up'"></i>
                </span>
            </div>
        }
    </div>
}

<div class="slide-controls">
    <span class="slide-control-button" (click)="nextSubStory()"><i class="theme-right"></i></span>
    <div class="slide-control-button-title-group">
        @if (stories[activeStory + 1]) {
            <span class="story-title next-title">{{ stories[activeStory + 1]?.title || '' }}</span>
        }
        <span class="slide-control-button" (click)="nextStory()"><i class="theme-move-right"></i></span>
    </div>
</div>
